import { LanguageInput } from "../input/LanguageInput";
import { PHPResponse } from "../PHPResponse";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";
import { EmailInput } from "./UserSignUpRequest";

export class EmailPasswordInput extends LanguageInput
{
  email:string;
  password:string;
}

export class UserLoginResponse extends PHPResponse
{
  userName:string;
}

export class UserLoginRequest extends PHPRequest<PHPAdress,EmailPasswordInput,UserLoginResponse>
{
  static readonly ADRESS = PHPAdresses.USER_LOGIN;

  constructor(){ super( UserLoginRequest.ADRESS ); }

}
